/** @jsx jsx **/
import { jsx } from "@emotion/react";

import { Button, Icon } from "@myrealtrip/design-system";

import * as styles from "./appstores.style";

export default function StoreButtons() {
  return (
    <div css={styles.rowStore}>
      <a
        href="https://apps.apple.com/app/id1141745032"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button type="outline">
          <Icon name="ic_appstore_20x20_gray_500" />
          <span>App Store</span>
        </Button>
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.mrt.ducati"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button type="outline">
          <Icon name="ic_googleplay_20x20_gray_500" />
          <span>Google Play</span>
        </Button>
      </a>
    </div>
  );
}
